import React from 'react'

import { Checkbox, FormControlLabel, Switch, Tooltip } from '@mui/material'

import { input } from '@albacross/frontend-utils'

type ToggleProps = {
  value: boolean
  onChange: (...args: any[]) => any
  color?: 'primary' | 'secondary'
  component?: 'switch' | 'checkbox'
  disabled?: boolean
  label?: string
  tooltip?: string
}

const Toggle = ({
  color = 'primary',
  component = 'checkbox',
  disabled = false,
  label = '',
  value,
  tooltip = '',
  onChange,
}: ToggleProps) => {
  const ToggleComponent: any = component === 'switch' ? Switch : Checkbox

  const toggle = (
    <ToggleComponent
      checked={value}
      color={color}
      disabled={disabled}
      onChange={(e: any) => onChange(e.currentTarget.checked)}
    />
  )

  const ContainerComponent: any = tooltip ? Tooltip : 'div'

  return (
    <ContainerComponent title={tooltip}>
      {label ? <FormControlLabel control={toggle} label={label} /> : toggle}
    </ContainerComponent>
  )
}

export default input(false)(Toggle as any)
